// extracted by mini-css-extract-plugin
export var smallSpinner = "_r6-0";